import {Navigate, Outlet, useMatch} from 'react-router-dom';

import {usePriceReport} from '../../hooks/usePriceReport';
import {ErrorPage} from '../../pages/ErrorPage/ErrorPage';
import {ExpiredPage} from '../../pages/ExpiredPage/ExpiredPage';
import {createPath, createRoute} from '../../utils/routing';

export function PriceReportRouteGuard() {
  const {isNotCreated, isLoading, isNotFound, isExpired, isError} = usePriceReport();
  const isCreatePage = !!useMatch(createPath);

  // Wait for loading to complete before making redirect decisions
  if (isLoading) {
    return null;
  }

  // Show error/expired/not found pages
  if (isExpired) {
    return <ExpiredPage data-testid="expiredPage" />;
  }

  if (isNotFound) {
    return <ErrorPage isNotFound data-testid="errorPage" />;
  }

  if (isError) {
    return <ErrorPage data-testid="errorPage" />;
  }

  // If price report is not created and we're not on the create page, redirect to create
  if (isNotCreated && !isCreatePage) {
    return <Navigate to={createRoute} replace />;
  }

  // Otherwise, render the child routes
  return <Outlet />;
}
